"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubSituationPatrimoniale = void 0;
exports.ESubSituationPatrimoniale = {
    proprietaire: "proprietaire",
    locataire: "locataire",
    loge_titre_gratuit: "loge_titre_gratuit",
};
